import { render, staticRenderFns } from "./bsy-menu.vue?vue&type=template&id=efd70962&scoped=true&"
import script from "./bsy-menu.vue?vue&type=script&lang=js&"
export * from "./bsy-menu.vue?vue&type=script&lang=js&"
import style0 from "./bsy-menu.vue?vue&type=style&index=0&id=efd70962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd70962",
  null
  
)

export default component.exports